import React from 'react';
import { playSound } from '../utils/soundEffects';
import { CountdownCircle } from './CountdownCircle';

interface GameControlsProps {
  status: import('../types').GameStatus;
  onStart: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onResolve: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onNext: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReset: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showCountdown: boolean;
  setShowCountdown: (value: boolean) => void;
  startDisabled?: boolean;
}

export const GameControls: React.FC<GameControlsProps> = ({
  status,
  onStart,
  onResolve,
  onNext,
  onReset,
  showCountdown,
  setShowCountdown,
  startDisabled,
}) => {
  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>, action: (event: React.MouseEvent<HTMLButtonElement>) => void) => {
    playSound('button');
    action(event);
  };

  const handleCloseCountdown = () => {
    setShowCountdown(false);
  };

  const handleStart = (e: React.MouseEvent<HTMLButtonElement>) => {
    setShowCountdown(false);
    onStart(e);
  };

  const handleResolve = (e: React.MouseEvent<HTMLButtonElement>) => {
    onResolve(e);
  };

  const handleNext = (e: React.MouseEvent<HTMLButtonElement>) => {
    onNext(e);
  };

  return (
    <div className="w-100 h-25 d-flex justify-content-center align-items-center">
      <dialog
        open={showCountdown}
        className={`countdown-dialog ${showCountdown ? '' : 'hidden'}`}
      >
        <div className="countdown-dialog-container">
          <button
            onClick={handleCloseCountdown}
            className="countdown-dialog-close-btn"
            title="Cerrar"
            aria-label="Cerrar temporizador"
          >
            ×
          </button>
          <CountdownCircle
            duration={60}
            onClose={undefined} /* Removed internal button */
            onComplete={handleCloseCountdown}
          />
        </div>
      </dialog>
      <button
        id="start"
        onClick={(event) => handleButtonClick(event, handleStart)}
        type="button"
        disabled={startDisabled}
        title={startDisabled ? 'Ajusta la escalera de fases: hay más fases que preguntas disponibles en alguna dificultad.' : undefined}
        className={"border border-white action-btn" + (status.step === "start" ? "" : " hidden")}
      >
        Empezar
      </button>
      <button
        id="resolve"
        onClick={(event) => handleButtonClick(event, handleResolve)}
        type="button"
        className={"border border-white action-btn" + (status.step === "resolve" ? "" : " hidden")}
      >
        Resolver
      </button>
      <button
        id="next"
        onClick={(event) => handleButtonClick(event, handleNext)}
        type="button"
        className={"border border-white action-btn" + (status.step === "next" ? "" : " hidden")}
      >
        Siguiente
      </button>

    </div>
  );
};
